// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace MonthlyVarianceReportConfig{

    export const ENTITY_LEVEL_LEFT_PAD = 16;
    export const ENTITY_LABEL_CELL_WIDTH = 240;

    // NOTE: ENABLE_ROW_FOLDING is currently only used to enable/disable summary rows
    export const ENABLE_ROW_FOLDING = false;

}